import { COMMERCIAL_PHONE } from './phones'

export const productPromoLinks = {
  accountingSpecialist: `https://api.whatsapp.com/send?phone=${COMMERCIAL_PHONE}`,
}
